import { useState, useEffect } from 'react';
import Select from 'react-select';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import '/src/features/supervision/conversations/components/ConversationFiltersBar/ConversationFiltersBar.css';
import './AgentsPerformanceProfil.css';
import AgentsPerformanceHeader from '../AgentsPerformanceHeader/AgentsPerformanceHeader';
import AgentsPerformanceArray from '../AgentsPerformanceArray/AgentsPerformanceArray';
import AgentsPerformanceService from '../../services/AgentsPerformanceService';
import PoleService from '../../services/PoleService';
import InputSearch from '/src/components/UI/InputSearch/InputSearch';

const DEFAULT_STATS = { overallScore: 0, interactions: 0, avgVoiceDuration: 0, speakerRatio: null, training: null, agents: [] };
const DEFAULT_FILTERS = { agent_id: "", pole_ids: [], date_start: "", date_end: "" };

function AgentsPerformanceProfil() {
    const { getAgentsPerformance } = AgentsPerformanceService;
    const { getPoles } = PoleService;

    const [data, setData] = useState(DEFAULT_STATS);
    const [isLoading, setIsLoading] = useState(true);
    const [filters, setFilters] = useState(DEFAULT_FILTERS);
    const [poleOptions, setPoleOptions] = useState([]);

    useEffect(() => {
        const fetchPoles = async () => {
            const [response, error] = await getPoles();
            if (error || !response) {
                console.error("Failed to fetch poles:", error);
                return;
            }
            setPoleOptions((response.data || []).map((p) => ({ value: p.id, label: p.name })));
        };

        fetchPoles();
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);

            const cleanedFilters = Object.fromEntries(
                Object.entries(filters).filter(
                    ([_, value]) => value !== "" && !(Array.isArray(value) && value.length === 0)
                )
            );
            const [response, error] = await getAgentsPerformance(cleanedFilters);

            if (error || !response) {
                console.error("Failed to fetch agents performance:", error);
                setIsLoading(false);
                return;
            }

            setData(response);
            setIsLoading(false);
        };

        fetchData();
    }, [filters]);

    return (
        <div className="agents-performance-profil">
            <AgentsPerformanceHeader stats={data} isLoading={isLoading} agentFilter={filters.agent_id} />
            <br></br>
            <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", alignItems: "flex-start" }}>
                <InputSearch
                    placeholderLibelle="Search agent"
                    name="agent_id"
                    defaultValue={filters.agent_id}
                    style={{ width: "240px", marginBottom: "10px" }}
                    onChange={(e) => setFilters(prev => ({ ...prev, agent_id: e.target.value }))}
                />
                <Select
                    classNamePrefix="criteria-select"
                    isMulti
                    options={poleOptions}
                    value={poleOptions.filter(opt => filters.pole_ids.includes(opt.value))}
                    getOptionValue={(opt) => opt.value}
                    onChange={(selected) =>
                        setFilters(prev => ({ ...prev, pole_ids: selected ? selected.map(s => s.value) : [] }))
                    }
                    hideSelectedOptions={false}
                    menuPortalTarget={document.body}
                    styles={{
                        option: (base, state) => ({
                            ...base,
                            backgroundColor: state.isSelected ? "var(--secondary)" : base.backgroundColor,
                            color: state.isSelected ? "var(--main)" : base.color
                        }),
                        container: (base) => ({ ...base, width: "210px", marginBottom: "10px" }),
                        menu: (base) => ({ ...base, marginTop: -10 }),
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    controlShouldRenderValue={false}
                    closeMenuOnSelect={false}
                    placeholder={
                        filters.pole_ids.length
                            ? `${filters.pole_ids.length} pole${filters.pole_ids.length > 1 ? "s" : ""} selected`
                            : "Filter by pole..."
                    }
                />
                <div className="container_dates">
                    <Tippy className="date-input-tooltip" content={<div className="date-input-text-tooltip">Date Start</div>} placement="top" delay={[200, 0]}>
                        <input type="date" className="input_search" value={filters.date_start}
                            onChange={(e) => setFilters(prev => ({ ...prev, date_start: e.target.value }))}
                        />
                    </Tippy>
                    <Tippy className="date-input-tooltip" content={<div className="date-input-text-tooltip">Date End</div>} placement="top" delay={[200, 0]}>
                        <input type="date" className="input_search" value={filters.date_end}
                            onChange={(e) => setFilters(prev => ({ ...prev, date_end: e.target.value }))}
                        />
                    </Tippy>
                </div>
            </div>
            <AgentsPerformanceArray agents={data.agents} isLoading={isLoading} />
        </div >
    );
}

export default AgentsPerformanceProfil;
